export const GET_AFIPS = "GET_AFIPS";
export const ADD_AFIP = "ADD_AFIP";
export const UPLOAD_AFIP = "UPLOAD_AFIP";